/* Pro Tan theme: content pages (About video, Contact topics, FAQ search/tabs, Partners map + filters).
   Loaded with defer only on pages that need it; each part checks for its own markup. */
(function () {
  "use strict";
  if (window.PT_PAGES_INIT) return; window.PT_PAGES_INIT = true;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = s => String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const live = m => (window.PT && PT.live ? PT.live(m) : null);

  /* ---------- About: click-to-load video ---------- */
  document.addEventListener("click", e => {
    const b = e.target.closest("[data-vid]"); if (!b) return;
    const f = document.createElement("div"); f.className = "vid-frame";
    const i = document.createElement("iframe");
    i.src = b.dataset.vid; i.title = b.dataset.vidTitle || "Video";
    i.allow = "autoplay; fullscreen; picture-in-picture; encrypted-media"; i.allowFullscreen = true;
    i.referrerPolicy = "strict-origin-when-cross-origin";
    f.appendChild(i); b.replaceWith(f); i.focus();
  });

  /* ---------- Contact: topics open the form ---------- */
  const ct = $("[data-contact]");
  if (ct) {
    const form = $("#ctForm"), sel = $("#ctTopicSel"), hint = $("[data-topic-hint]", ct);
    const map = {};
    $$("[data-topic]", ct).forEach(b => (map[b.dataset.topic] = { show: b.dataset.show === "true", order: b.dataset.order === "true" }));
    const tpl = $("template[data-topic-map]", ct);
    if (tpl) $$("i", tpl.content).forEach(i => (map[i.dataset.key] = { show: i.dataset.show === "true", order: i.dataset.order === "true" }));
    const cond = key => { const m = map[key] || {}; $$("[data-cond]", ct).forEach(f => (f.hidden = !m[f.dataset.cond])); };
    const keyOfSelect = () => { const o = sel && sel.selectedOptions[0]; return o ? o.dataset.key : ""; };
    const settled = $("#ctOk") || $("#ctErr");
    if (sel) { sel.addEventListener("change", () => cond(keyOfSelect())); cond(keyOfSelect()); }
    if (ct.dataset.layout === "topics" && form) {
      const tf = $("[data-topic-field]", ct); if (tf) tf.hidden = true;
      if (!settled) { form.hidden = true; if (hint) hint.hidden = false; }
      ct.addEventListener("click", e => {
        const b = e.target.closest("[data-topic]"); if (!b) return;
        $$("[data-topic]", ct).forEach(x => x.setAttribute("aria-pressed", x === b));
        if (sel) { const o = $$("option", sel).find(o => o.dataset.key === b.dataset.topic); if (o) sel.value = o.value; }
        form.hidden = false; if (hint) hint.hidden = true; cond(b.dataset.topic);
        const n = $("#ctName"); n && n.focus();
      });
    }
    const ok = $("#ctOk"); if (ok) ok.focus();
  }

  /* ---------- FAQ: search, tabs, side menu ---------- */
  const faq = $("[data-faq]");
  if (faq) {
    const nav = faq.dataset.nav, q = $("#faqS"), groups = $$("[data-faq-group]", faq), none = $("#faqNone"), countEl = $("#faqN");
    let tab = groups[0] ? groups[0].dataset.faqGroup : null;
    const tabs = $$("[data-faqtab]", faq);
    const apply = () => {
      const term = q ? q.value.trim().toLowerCase() : "";
      let total = 0;
      groups.forEach(g => {
        let n = 0;
        $$("[data-faq-item]", g).forEach(d => { const hit = !term || d.textContent.toLowerCase().includes(term); d.hidden = !hit; if (term) d.open = hit; if (hit) n++; });
        total += n;
        const inTab = nav !== "tabs" || term || g.dataset.faqGroup === tab;
        g.hidden = !n || !inTab;
        const c = $(`[data-faq-count="${g.dataset.faqGroup}"]`, faq); if (c) { c.textContent = n; c.parentElement.hidden = !n; }
        const t = $(`[data-faqtab="${g.dataset.faqGroup}"]`, faq); if (t) t.hidden = term && !n;
      });
      if (none) none.hidden = total > 0;
      if (countEl) countEl.textContent = `${total} answer${total === 1 ? "" : "s"}`;
    };
    if (nav === "tabs" && tabs.length) {
      tab = tabs[0].dataset.faqtab; tabs[0].setAttribute("aria-pressed", "true");
      faq.addEventListener("click", e => {
        const b = e.target.closest("[data-faqtab]"); if (!b) return;
        tab = b.dataset.faqtab; tabs.forEach(x => x.setAttribute("aria-pressed", x === b));
        if (q && q.value) q.value = "";
        apply();
      });
    }
    faq.addEventListener("click", e => {
      const j = e.target.closest("[data-faqjump]"); if (!j) return;
      const h = document.getElementById("fgh-" + j.dataset.faqjump);
      if (h) setTimeout(() => h.focus({ preventScroll: true }), 0);
    });
    if (q) q.addEventListener("input", apply);
    apply();
  }

  /* ---------- copy email ---------- */
  document.addEventListener("click", e => {
    const b = e.target.closest("[data-copy]"); if (!b) return;
    const v = b.dataset.copy, label = b.firstChild;
    const done = () => { label.textContent = "Copied"; setTimeout(() => (label.textContent = "Copy email"), 1800); live("Email copied"); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(done, () => live(v));
    else live(v);
  });

  /* ---------- Partners ---------- */
  const root = $("[data-partners]");
  if (!root) return;
  let data = [];
  try { data = JSON.parse(($("#partnersData") || {}).textContent || "[]"); } catch (_) {}
  const contactUrl = root.dataset.contact || "/pages/contact";
  const ROLE = { spray: "Spray tan team", dist: "Distributor", affiliate: "Certified affiliate", open: "Open territory" };
  const REGION_NAMES = { world: "World", americas: "Americas", europe: "Europe", mea: "Middle East & Africa", apac: "Asia-Pacific" };
  const ww = { layer: "all", region: "world", sel: null, vb: null };
  const fits = p => ww.layer === "all" || (p.roles || []).includes(ww.layer) || (p.roles || []).includes("open");

  /* list view (and the fallback list): filter by layer */
  function filterList() {
    $$("#wwList .partner").forEach(p => { const roles = (p.dataset.roles || "").split(" "); p.hidden = !(ww.layer === "all" || roles.includes(ww.layer) || roles.includes("open")); });
    $$("#wwList [data-ww-country]").forEach(c => (c.hidden = !$$(".partner:not([hidden])", c).length));
    $$("#wwList .ww-list-only").forEach(g => { const any = $$("[data-ww-country]:not([hidden])", g).length; g.hidden = !any; const h = g.previousElementSibling; if (h && h.matches(".month-h")) h.hidden = !any; });
  }
  root.addEventListener("click", e => {
    const L = e.target.closest("[data-layer]"); if (!L) return;
    ww.layer = L.dataset.layer; $$("[data-layer]", root).forEach(b => b.setAttribute("aria-pressed", b === L));
    filterList();
    if (mapOn) { if (ww.sel) { ww.sel = ww.sel.filter(i => countries[i].partners.some(fits)); if (!ww.sel.length) ww.sel = null; } render(false); }
  });

  /* map view */
  const M = window.PT_MAP, ui = $("#wwMapUI");
  const mapOn = !!(M && ui && data.length);
  if (!mapOn) return;
  const countries = [];
  data.forEach(p => {
    let c = countries.find(x => x.country === p.country);
    if (!c) { const rg = String(p.region || "americas").toLowerCase(); c = { country: p.country, region: ["americas", "europe", "mea", "apac"].includes(rg) ? rg : "apac", lat: p.lat, lng: p.lng, partners: [] }; countries.push(c); }
    if ((!c.lat && !c.lng) && (p.lat || p.lng)) { c.lat = p.lat; c.lng = p.lng; }
    c.partners.push(p);
  });
  countries.forEach(c => (c.open = c.partners.every(p => (p.roles || []).includes("open"))));
  const proj = (lng, lat) => {
    const l = lng * Math.PI / 180, f = lat * Math.PI / 180, f2 = f * f, f4 = f2 * f2;
    const x = l * (0.8707 - 0.131979 * f2 + f4 * (-0.013791 + f4 * (0.003971 * f2 - 0.001529 * f4)));
    const y = f * (1.007226 + f2 * (0.015085 + f4 * (-0.044475 + 0.028874 * f2 - 0.005916 * f4)));
    return { x: M.proj.tx + M.proj.k * x, y: M.proj.ty - M.proj.k * y };
  };
  countries.forEach(c => { c.hasXY = !!(Number(c.lat) || Number(c.lng)); Object.assign(c, proj(Number(c.lng) || 0, Number(c.lat) || 0)); });

  const wrap = $("#mapWrap");
  wrap.insertAdjacentHTML("afterbegin", `<svg id="mapSvg" viewBox="0 0 1000 520" aria-hidden="true" focusable="false"><path class="land" d="${M.land}"/><path class="borders" d="${M.borders}"/></svg>`);
  ui.hidden = false;
  const fb = $("[data-ww-fallback]"); if (fb) fb.hidden = true;

  function partnerHTML(p) {
    const roles = (p.roles || []).filter(r => r !== "hq" && ROLE[r]);
    const where = p.address || p.city;
    const dom = p.web ? String(p.web).replace(/^https?:\/\//, "").replace(/^www\./, "").split("/")[0] : "";
    const href = p.web ? (/^https?:\/\//.test(p.web) ? p.web : "https://" + p.web) : "";
    return `<div class="partner"><h4>${esc(p.name)}</h4><div class="rl">${roles.map(r => `<span class="tag ${r === "spray" ? "tag-dark" : r === "open" ? "tag-acc" : ""}">${ROLE[r]}</span>`).join("")}</div>
      ${p.note ? `<p class="muted" style="font-size:.88rem">${esc(p.note)}</p><a class="btn btn-primary btn-sm" href="${esc(contactUrl)}" style="justify-self:start">Apply to represent Pro Tan®</a>` : ""}
      ${where ? `<div class="rowc muted">${esc(where)}</div>` : ""}
      <div class="rowc">${href ? `<a class="link" href="${esc(href)}" target="_blank" rel="noopener">${esc(dom)}<span class="sr-only"> (opens in a new tab)</span></a>` : ""}${p.email ? `<span class="mono" style="word-break:break-all">${esc(p.email)}</span><button type="button" class="copy-btn" data-copy="${esc(p.email)}">Copy email<span class="sr-only"> ${esc(p.email)}</span></button>` : ""}${p.phone ? `<span class="mono">${esc(p.phone)}</span>` : ""}</div></div>`;
  }

  function render(animate) {
    const target = M.views[ww.region], from = ww.vb || target; ww.vb = target;
    const svg = $("#mapSvg"), reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (animate && !reduce) { const t0 = performance.now(); const step = now => { const k = Math.min(1, (now - t0) / 450), q = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2; svg.setAttribute("viewBox", from.map((v, i) => v + (target[i] - v) * q).join(" ")); if (k < 1) requestAnimationFrame(step); }; requestAnimationFrame(step); }
    else svg.setAttribute("viewBox", target.join(" "));
    const W = wrap.clientWidth || 800, H = W * 520 / 1000;
    const vis = countries.map((c, i) => ({ c, i, list: c.partners.filter(fits) })).filter(o => o.list.length);
    const placed = vis.filter(o => o.c.hasXY);
    const pts = placed.map(o => ({ ...o, px: (o.c.x - target[0]) / target[2] * W, py: (o.c.y - target[1]) / target[3] * H })).filter(o => o.px > -10 && o.px < W + 10 && o.py > -10 && o.py < H + 10);
    let html;
    if (ww.region === "world" && W < 640) html = `<p class="map-hint">Choose a region above</p>`;
    else if (ww.region === "world") html = ["americas", "europe", "mea", "apac"].map(r => { const g = pts.filter(o => o.c.region === r); if (!g.length) return ""; const n = g.filter(o => !o.c.open).length;
      return `<button type="button" class="pin cluster region" style="left:${g.reduce((s, o) => s + o.px, 0) / g.length / W * 100}%;top:${g.reduce((s, o) => s + o.py, 0) / g.length / H * 100}%" data-zoom="${r}" aria-label="${REGION_NAMES[r]}: ${n} countries. Zoom in">${REGION_NAMES[r]} <span class="n">${n}</span></button>`; }).join("");
    else {
      const used = new Set(), groups = [];
      pts.forEach(a => { if (used.has(a.i)) return; const g = [a]; used.add(a.i); pts.forEach(b => { if (!used.has(b.i) && Math.hypot(a.px - b.px, a.py - b.py) < 36) { g.push(b); used.add(b.i); } }); groups.push(g); });
      const cen = g => [g.reduce((s, o) => s + o.px, 0) / g.length, g.reduce((s, o) => s + o.py, 0) / g.length];
      for (let merged = true; merged;) { merged = false; outer: for (let x = 0; x < groups.length; x++) for (let y = x + 1; y < groups.length; y++) { const [ax, ay] = cen(groups[x]), [bx, by] = cen(groups[y]); if (Math.hypot(ax - bx, ay - by) < 38) { groups[x] = groups[x].concat(groups[y]); groups.splice(y, 1); merged = true; break outer; } } }
      html = groups.map(g => { const [cx, cy] = cen(g), ids = g.map(o => o.i), on = ww.sel && ww.sel.join() === ids.join(), pos = `left:${cx / W * 100}%;top:${cy / H * 100}%`;
        if (g.length > 1) return `<button type="button" class="pin cluster" style="${pos}" data-group="${ids.join(",")}" aria-pressed="${!!on}" aria-label="${g.length} countries close together: ${esc(g.map(o => o.c.country).join(", "))}. Show all">${g.length}</button>`;
        const o = g[0], sp = o.list.some(p => (p.roles || []).includes("spray"));
        return `<button type="button" class="pin ${o.c.open ? "open" : sp ? "" : "dist"}" style="${pos}" data-country="${o.i}" aria-pressed="${!!on}" aria-label="${esc(o.c.country)}: ${o.c.open ? "open territory" : o.list.length + " partner" + (o.list.length > 1 ? "s" : "")}">${o.c.open ? "+" : o.list.length}</button>`; }).join("");
    }
    $("#pins").innerHTML = html;
    const inR = c => ww.region === "world" || c.region === ww.region;
    const lc = vis.filter(o => inR(o.c));
    $("#wwCount").textContent = `${lc.filter(o => !o.c.open).length} countries${ww.region === "world" ? "" : " in " + REGION_NAMES[ww.region]}`;
    $("#cList").innerHTML = ["americas", "europe", "mea", "apac"].filter(r => lc.some(o => o.c.region === r)).map(r => `<p class="rh">${REGION_NAMES[r]}</p>` + lc.filter(o => o.c.region === r).sort((a, b) => a.c.country.localeCompare(b.c.country)).map(o => { const sp = o.list.some(p => (p.roles || []).includes("spray")), di = o.list.some(p => (p.roles || []).includes("dist"));
      return `<button type="button" data-country="${o.i}" aria-pressed="${!!(ww.sel && ww.sel.length === 1 && ww.sel[0] === o.i)}"><span>${esc(o.c.country)}</span><span>${o.c.open ? `<span class="r">Open</span>` : `${sp ? `<span class="r">Spray</span>` : ""}${di ? `<span class="r">Dist.</span>` : ""}`}</span></button>`; }).join("")).join("");
    const d = $("#wwDetail");
    if (!ww.sel) d.innerHTML = `<p class="muted" style="font-size:.9rem">Select a region, pin or country to see who to contact.</p>`;
    else d.innerHTML = (ww.sel.length > 1 ? `<h3 id="wwSelH" tabindex="-1">${ww.sel.length} countries</h3>` : "") + ww.sel.map(ci => { const c = countries[ci]; return `${ww.sel.length > 1 ? `<h4 class="eyebrow">${esc(c.country)}</h4>` : `<h3 id="wwSelH" tabindex="-1" class="h-sm d">${esc(c.country)}</h3>`}${c.partners.filter(fits).map(partnerHTML).join("")}`; }).join("");
    if (window.PT && PT.fixDots) PT.fixDots(d);
  }
  const setRegion = r => { ww.region = r; $$("[data-region]", root).forEach(b => b.setAttribute("aria-pressed", b.dataset.region === r)); };
  const focusSel = () => { const h = $("#wwSelH"); if (h) { h.scrollIntoView({ block: "nearest", behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" }); h.focus({ preventScroll: true }); } };
  root.addEventListener("click", e => {
    const G = e.target.closest("[data-group]"); if (G) { ww.sel = G.dataset.group.split(",").map(Number); render(false); focusSel(); return; }
    const R = e.target.closest("[data-region]"); if (R) { setRegion(R.dataset.region); render(true); return; }
    const Z = e.target.closest("[data-zoom]"); if (Z) { setRegion(Z.dataset.zoom); render(true); live("Zoomed to " + REGION_NAMES[ww.region]); const f = $("#pins .pin"); f && f.focus(); return; }
    const C = e.target.closest("[data-country]"); if (C) {
      const i = Number(C.dataset.country), fromList = !!C.closest("#cList"); ww.sel = [i];
      if (fromList && ww.region !== countries[i].region) { setRegion(countries[i].region); render(true); } else render(false);
      focusSel();
    }
  });
  let rT; addEventListener("resize", () => { clearTimeout(rT); rT = setTimeout(() => render(false), 150); });
  render(false);
})();
